import * as React from 'react';
import { ClassNames } from '@emotion/react';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';
import { tooltip, tooltipArrow } from 'ui/Tooltip/tooltipCssDefs';

export type TooltipProps = MuiTooltipProps;

/**
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * ```js
 * import { Tooltip } from 'ui';
 * ```
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Tooltip: React.FunctionComponent<React.PropsWithChildren<TooltipProps>> = ({
  arrow,
  children,
  ...rest
}) => {
  return (
    <ClassNames>
      {({ css, theme }) => (
        <MuiTooltip
          {...rest}
          classes={{ tooltip: css(tooltip(theme)), arrow: css(tooltipArrow(theme)) }}
          arrow
        >
          {children}
        </MuiTooltip>
      )}
    </ClassNames>
  );
};

export default Tooltip;
